import PropTypes from 'prop-types';

import { useUserSettings } from '#settingsFeature/models/userSettings/queries';

import AiTodayTodoList from '../../activities/AiTodayTodoList/AiTodayTodoList';
import TodayTodosList from '../../activities/TodayTodosList/TodayTodosList';

const CrmDashboardView = ({ onOpenCompany }) => {
	const { data: settings } = useUserSettings();
	const aiEnabled = settings?.userSettings?.aiNextActionEnabled !== false;

	return (
		<>
			{aiEnabled && <AiTodayTodoList onOpenCompany={onOpenCompany} />}
			<TodayTodosList onOpenCompany={onOpenCompany} />
		</>
	);
};

CrmDashboardView.propTypes = {
	onOpenCompany: PropTypes.func.isRequired,
};

export default CrmDashboardView;
